function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { Action } from "../Action";
import { HeartOutlineIcon, BankIcon, HappyFaceIcon, EmailIcon, SignInIcon } from "../Icons";



export const AccountActions = ({
  actionsProps,
  unreadMessages }) =>
{
  const theme = useContext(ThemeContext);

  const { Wishlist, YourPayments, ReferralCode, ContactUs, SignIn } = actionsProps;

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    Wishlist && !Wishlist.isHidden && /*#__PURE__*/
    React.createElement(Action, _extends({},
    Wishlist, {
      icon: /*#__PURE__*/React.createElement(HeartOutlineIcon, { color: theme.colors.secondary, size: "24px" }) })),


    YourPayments && !YourPayments.isHidden && /*#__PURE__*/
    React.createElement(Action, _extends({},
    YourPayments, {
      icon: /*#__PURE__*/React.createElement(BankIcon, { color: theme.colors.secondary, size: "24px" }) })),


    ReferralCode && !ReferralCode.isHidden && /*#__PURE__*/
    React.createElement(Action, _extends({},
    ReferralCode, {
      icon: /*#__PURE__*/React.createElement(HappyFaceIcon, { color: theme.colors.secondary, size: "24px" }) })),


    ContactUs && !ContactUs.isHidden && /*#__PURE__*/
    React.createElement(Action, _extends({},
    ContactUs, {
      icon: /*#__PURE__*/React.createElement(EmailIcon, { color: theme.colors.secondary, size: "24px" }),
      textColor: unreadMessages > 0 ? theme.colors.secondary : undefined,
      descriptionColor: unreadMessages > 0 ? theme.colors.secondary : undefined,
      hasCircleBadge: unreadMessages > 0,
      circleBadgeText: unreadMessages,
      circleBadgeColor: theme.colors.negative,
      circleBadgeBorderColor: theme.colors.ElementBackground,
      circleBadgeTextColor: theme.colors.Background })),


    SignIn && !SignIn.isHidden && /*#__PURE__*/
    React.createElement(Action, _extends({},
    SignIn, {
      icon: /*#__PURE__*/React.createElement(SignInIcon, { color: theme.colors.secondary, size: "24px" }) }))));




};